import React from "react";

import NavBar from "locale-scrolling-nav";

export default class Dropdown extends React.Component {
  state = {
    listVisible: false
  };

  show = () => {
    this.setState({ listVisible: true });
    document.addEventListener("click", this.hide);
  };
  getListStyle = () => {
    const ulStyle = {
      display: "block !important"
    };
    const listStyle = {
      width: "max-content !important"
    };
    const divStyle = {
      height: "100% !important;"
    };
    const hrefStyle = {
      color: "black !important"
    };
    return {
      ulStyle,
      listStyle,
      divStyle,
      hrefStyle
    };
  };
  hide = () => {
    this.setState({ listVisible: false });
    document.removeEventListener("click", this.hide);
  };
  render() {
    const { name, list, handleClick } = this.props;
    const { ulStyle, listStyle, divStyle, hrefStyle } = this.getListStyle();
    const { listVisible } = this.state;
    return (
      <div className={"dropdown-container" + (listVisible ? " show" : "")}>
        <div
          className={`dropdown-display  ${(listVisible && " clicked") ||
            ""} ${(name !== "More" && "active") || ""} `}
          onClick={this.show}
        >
          <span>{name}</span>
          <i className="icon icon-arrow-3 open" />
        </div>
        <div className="dropdown-list">
          <NavBar
            divStyle={divStyle}
            ulStyle={ulStyle}
            wrapperListElementClass="main-list-item"
            wrapperUlClass="main-list-element"
            listStyle={listStyle}
            hrefStyle={hrefStyle}
            activeLinkClass="active"
            handleClick={handleClick}
            offset={-200}
            duration={500}
            delay={0}
            height="250px"
            backgroundColor="white"
            disabledElement={true}
            items={list}
          />
        </div>
      </div>
    );
  }
}
